export default "__VITE_ASSET__ZJV3tTGh__"